<template>
  <div class="catalog-hero bg-color-off-black">
    <img
      :src="bgImage || '/images/Everything-Header-3---PERFORM.png'"
      class="img-object-fit catalog-hero__img fadeInSimple"
      v-show="!isLoading"
      :alt="activeCategory.Name"
    />
    <div class="catalog-hero__contents row" v-if="!isLoading">
      <div class="col-12">
        <h2>
          <p class="no-bottom-margin color-white">
            <span v-if="catalog !== 'authors'" class="catalog-hero__category type-capital">{{ catalog }}:</span><br />
            <span v-if="currentCollectionName" class="catalog-hero__title">{{ currentCollectionName }}</span>
          </p>
        </h2>
        <div
          v-if="catalog === 'authors'"
          class="catalog-hero__description color-white type-regular"
        >
          Find an author by entering their name in the search field below.
        </div>
        <div
          v-if="currentCollectionDescription && !isLoading && catalog !== 'authors'"
          class="catalog-hero__description color-white type-regular"
          v-html="currentCollectionDescription"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "CatalogHero",
  props: ["catalog"],
  data() {
    return {
      currentCollection: 0,
      everythingOptionName: "",
    };
  },
  metaInfo() {
    return {
      title: this.currentCollectionName,
      titleTemplate: "%s | Concord Theatricals",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.activeCategory.Description,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("setCatalog", this.catalog);
    this.everythingOptionName =
      this.catalog == "authors" ? "All" : "Everything";
  },
  methods: {
    getOptionLabel(option) {
      const name = option.Name;
      const total = this.availableCategories.find((cat) => cat.Id == option.Id);
      if (typeof total !== "undefined") {
        return `${name} (${total.TotalProducts})`;
      }
    },
  },

  computed: {
    ...mapState({
      activeCategory: (state) => state.catalogStore.activeCategory,
      totalProducts: (state) => state.catalogStore.totalProducts,
      isLoading: (state) => state.catalogStore.isLoading,
      locale: (state) => state.catalogStore.locale,
    }),

    ...mapGetters([
      "availableCategories",
      "currentCollectionDescription",
    ]),

    currentCollectionName() {
      if (this.catalog == "authors") {
        return "Concord Theatricals Authors";
      }
      if (
        this.activeCategory.Name === "The Concord Theatricals Catalog" &&
        this.locale === "UK"
      ) {
        return "The Concord Theatricals Catalogue";
      }
      return this.activeCategory.Name;
    },

    bgImage() {
      if (this.isLoading) {
        // basic black gif
        return "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
      }

      if (typeof this.activeCategory !== "undefined" && this.activeCategory.HeroImageUrl !== "") {
        return this.activeCategory.HeroImageUrl;
      }

      return "/images/Everything-Header-3---PERFORM.png";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogHero.vue